import type { ComponentPropsWithoutRef } from 'react';

const SIZE_CLASS = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
} as const;

type ContainerSize = keyof typeof SIZE_CLASS;

interface ContainerProps extends ComponentPropsWithoutRef<'div'> {
  size?: ContainerSize;
}

export function Container({ size = 'lg', className, ...props }: ContainerProps) {
  return (
    <div
      className={['mx-auto w-full px-4 sm:px-6 lg:px-8', SIZE_CLASS[size], className]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
